import { UnknownAction } from "@reduxjs/toolkit";
import {
  AUTHENTICATING_LINKEDIN_ACCOUNT,
  AUTHENTICATING_LINKEDIN_ACCOUNT_FAILED,
  AUTHENTICATING_LINKEDIN_ACCOUNT_SUCCEEDED,
  FETCH_LINKEDIN_INTEGRATION,
  FETCHING_LINKEDIN_INTEGRATION_FAILED,
  FETCHING_LINKEDIN_INTEGRATION_SUCCEEDED,
  DEACTIVATE_LINKEDIN_ACCOUNT,
  DEACTIVATING_LINKEDIN_ACCOUNT_FAILED,
  DEACTIVATING_LINKEDIN_ACCOUNT_SUCCEEDED,
  INVALIDATE_LINKEDIN_INTEGRATION,
  SHARE_LINKEDIN_POST_REQUEST,
  SHARING_LINKEDIN_POST_SUCCEEDED,
  SHARING_LINKEDIN_POST_FAILED,
  INVALIDATE_LINKEDIN_POST
} from 'src/redux/actions/actionTypes';

interface IInitialState {

  authentication: {
    loading: boolean;
    error: any;
    succeeded: boolean;
  },
  deactivation: {
    loading: boolean;
    error: any;
    succeeded: boolean;
  },
  post:{
    posting: boolean;
    error: any;
    succeeded: boolean;
  }
  item: any;
  loading: boolean;
  error: any;
  succeeded: boolean;
}
const initialState: IInitialState = {
  authentication: {
    loading: false,
    error: null,
    succeeded: false
  },
  deactivation: {
    loading: false,
    error: null,
    succeeded: false
  },
  post:{
    posting: false,
    error: null,
    succeeded: false
  },
  item: null,
  loading: false,
  error: null,
  succeeded: false
}


export function linkedInReducer(state: IInitialState = initialState, action: UnknownAction): IInitialState {
  switch (action.type) {
    case AUTHENTICATING_LINKEDIN_ACCOUNT: {
      return {
        ...state,
        authentication: {
          ...state.authentication,
          loading: true
        }
      }
    }
    case AUTHENTICATING_LINKEDIN_ACCOUNT_SUCCEEDED: {
      return {
        ...state,
        authentication: {
          ...state.authentication,
          loading: false,
          succeeded: true
        },
        item: action.payload
      }
    }

    case AUTHENTICATING_LINKEDIN_ACCOUNT_FAILED: {  
      return {
        ...state,
        authentication: {
          ...state.authentication,
          loading: false,
          error: action.payload
        }
      }
    }

    case FETCH_LINKEDIN_INTEGRATION: {
      return {
        ...state,
        loading: true,
        succeeded: false,
        error: null
      }
    }

    case FETCHING_LINKEDIN_INTEGRATION_SUCCEEDED: {
      return {
        ...state,
        loading: false,
        succeeded: true,
        item: action.payload,
        error: null
      }
    }

    case FETCHING_LINKEDIN_INTEGRATION_FAILED: {
      return {
        ...state,
        loading: false,
        succeeded: false,
        error: action.payload
      }
    }

    case DEACTIVATE_LINKEDIN_ACCOUNT: {
      return {
        ...state,
        deactivation: {
          ...state.deactivation,
          loading: true
        }
      }
    }

    case DEACTIVATING_LINKEDIN_ACCOUNT_SUCCEEDED: {
      return {
        ...initialState,
        deactivation: {
          error: null,
          loading: false,
          succeeded: true
        },
      }
    }

    case DEACTIVATING_LINKEDIN_ACCOUNT_FAILED: {
      return {
        ...state,
        deactivation: {
          ...state.deactivation,
          loading: false,
          error: action.payload
        }
      }
    }

    case INVALIDATE_LINKEDIN_INTEGRATION: {
      return initialState;
    }

    case SHARE_LINKEDIN_POST_REQUEST:{
      return {
        ...state,
        post: {
          ...state.post,
          posting: true
        }
      }
    }

    case SHARING_LINKEDIN_POST_SUCCEEDED:{
      return {
        ...state,
        post: {
          ...state.post,
          posting: false,
          succeeded: true
        }
      }
    }

    case SHARING_LINKEDIN_POST_FAILED:{
      return {
        ...state,
        post: {
          ...state.post,
          posting: false,
          error: action.payload
        }
      }
    }

    case INVALIDATE_LINKEDIN_POST:{
      return {
        ...state,
        post: {
          posting: false,
          error: null,
          succeeded: false
        }
      }
    }


    default: {
      return state;
    }
  }
}